<ng-container *ngIf='!loading, else isLoading'>
  <div class='row mt--lg'>
    <div class='column--12 column-lg--8 column-xxl--5'>
      <mat-form-field class='w-100' *ngIf="supportedAirports.length > 0">
        <mat-label>Select origin airport</mat-label>
        <mat-select name='airportCode' [(value)]='selectedAirport' (selectionChange)='getAWBs()'>
          <mat-option *ngFor='let airport of supportedAirports' value="{{ airport.code }}">{{ airport.code }} ({{airport.name}})</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class='container ml--none mt--sm' *ngIf='selectedAirport'>
    <ng-container *ngIf='!loadingAWBs, else isLoadingAWBs'>
      <ng-container *ngIf='groupedAWBs && groupedAWBs.length > 0, else noAWBs'>
        <div class='responsive-table'>
          <table mat-table [dataSource]="groupedAWBs" multiTemplateDataRows matSort>
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef style='width: 50px'></th>
              <td mat-cell *matCellDef="let element" class='text--sm'>
                <button
                  mat-icon-button
                  color='primary'
                  class='mat-small-icon mx--xs'
                  (click)='toggleAWBDetails(element)'
                ><mat-icon [ngClass]="element === expandedElement ? 'icon-minus' : 'icon-plus'"></mat-icon></button>
              </td>
            </ng-container>
            <ng-container matColumnDef="sortDate">
              <th mat-header-cell *matHeaderCellDef style='width: 250px'>Sort Date</th>
              <td mat-cell *matCellDef="let element" class='text--sm'>
                <div class='row' style='align-items:center'>
                  <div class='column--auto'>
                    <h3 class='no-bold'>{{ element.sortDate }}</h3>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Flight Date</th>
              <td mat-cell *matCellDef="let element" class='text--sm'>
                <div class='row' style='align-items:center'>
                  <div class='column--auto'>
                    <h3 class='no-bold'>{{ element.shipDate | timeToString : DATE_FORMAT : DefaultTimezone }}</h3>
                  </div>
                  <div class='column--auto ml--auto align-right'>
                    <button mat-flat-button color='primary' (click)='downloadAllAWBLabelsForDate(element.shipDate)'>Download All</button>
                  </div>
                </div>
              </td>
            </ng-container>

            <!-- Adjustment Details -->
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let group" [attr.colspan]="displayedColumns.length">
                <div class="expanded-awb-detail" [@detailExpand]="group === expandedElement ? 'expanded' : 'collapsed'">
                  <div class='row mt--md mb--md p--sm'>
                    <div class='column--12'>
                      <awb-listing [awbs]='group.awbs' [canEditAwb]='canEditAwb' [user]='user' (refreshAwbs)='getAWBs()'></awb-listing>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
            <tr style="height: 0" mat-row *matRowDef="let group; columns:['expandedDetail']"></tr>
          </table>
        </div>
      </ng-container>
      <ng-template #noAWBs>
        <div class='row justify-content-center'>
          <div class='column--12 align-center'>
            <div style='width: 220px; margin: 0 auto;'>
              <img src='{{ CDN_URL }}/admin/images/empty-history_animated.svg' />
              <p>No awbs found for this location</p>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
    <ng-template #isLoadingAWBs>
      <div class='align-center mt--lg'>
        <app-loading></app-loading>
      </div>
    </ng-template>
  </div>
</ng-container>
<ng-template #isLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
